import { helloWorld } from './message';

document.getElementById('app')!.innerHTML = `<h1>${helloWorld()}</h1>`;
